import { FactoryProps, TiledResource } from "@excaliburjs/plugin-tiled";
import {
  Animation,
  AnimationStrategy,
  ImageSource,
  Loader,
  range,
  SpriteSheet,
  vec,
} from "excalibur";
import { Building } from "./actors/building";
import { typeSafeObjectFromEntries } from "./common";
import { GetPlayable, TileSize } from "./constants";
import {
  CardKind,
  CardKinds,
  CardLevel,
  CardLevels,
  GameResource,
  TowerAnimationSet,
} from "./types";

const playablesPng = new ImageSource("./images/playables.png");
const resourcesPng = new ImageSource("./images/resources_20.png");

// It is convenient to put your resources in one place
export const Resources = {
  Map1: new TiledResource("./maps/map1.tmx", {
    layerConfig: {
      pathing: {
        //isSolid: true,
        useTileColliders: true,
        useTileCollidersWhenInvisible: true,
      },
    },

    entityClassNameFactories: {
      playable: (props: FactoryProps) => {
        try {
          const playableId = props.properties.get("playableid");
          return new Building({
            tilePos: vec(
              Math.floor(props.worldPos.x / TileSize),
              Math.floor(props.worldPos.y / TileSize) - 1,
            ),
            playable: GetPlayable(playableId),
          });
        } catch (e) {
          console.log("Failed to intiailize", props);
          console.error(e);
          throw e;
        }
      },
    },
  }),

  resourcesPng,
  playablesPng,
} as const; // the 'as const' is a neat typescript trick to get strong typing on your resources.
// So when you type Resources.Sword -> ImageSource

export const playables = SpriteSheet.fromImageSource({
  image: playablesPng,
  spacing: { margin: { x: 0, y: 0 }, originOffset: { x: 0, y: 0 } },
  grid: { spriteHeight: TileSize, spriteWidth: TileSize, columns: 10, rows: 5 },
});

export const resources = SpriteSheet.fromImageSource({
  image: resourcesPng,
  spacing: { margin: { x: 0, y: 0 }, originOffset: { x: 0, y: 0 } },
  grid: { spriteHeight: 20, spriteWidth: 20, columns: 6, rows: 6 },
});

export const ResourceSprites: Record<GameResource, Animation> = {
  fuel: Animation.fromSpriteSheet(
    resources,
    range(0, 0),
    0,
    AnimationStrategy.Freeze,
  ),
  food: Animation.fromSpriteSheet(
    resources,
    range(2, 2),
    0,
    AnimationStrategy.Freeze,
  ),
  ore: Animation.fromSpriteSheet(
    resources,
    range(3, 3),
    0,
    AnimationStrategy.Freeze,
  ),
  fight: Animation.fromSpriteSheet(
    resources,
    range(4, 4),
    0,
    AnimationStrategy.Freeze,
  ),
  money: Animation.fromSpriteSheet(
    resources,
    range(5, 5),
    0,
    AnimationStrategy.Freeze,
  ),
};

function cardSprite({ kind, level }: { kind: CardKind; level: CardLevel }) {
  const maxLevel = 9;
  const spriteIdx = CardKinds.indexOf(kind);
  return spriteIdx * (maxLevel + 1) + level;
}

export const TowerAnimations: Record<
  `${CardKind}-${CardLevel}`,
  TowerAnimationSet
> = typeSafeObjectFromEntries(
  CardKinds.flatMap((kind) =>
    CardLevels.map((level) => {
      const cardIdx = cardSprite({ kind, level });
      console.log([cardIdx, kind, level]);
      const spriteSheet = playables;
      return [
        `${kind}-${level}`,
        {
          idle: Animation.fromSpriteSheet(
            spriteSheet,
            range(cardIdx, cardIdx),
            0,
            AnimationStrategy.Freeze,
          ),
          die: Animation.fromSpriteSheet(
            spriteSheet,
            range(
              cardSprite({ kind, level: 0 }),
              cardSprite({ kind, level: 0 }),
            ),
            0,
            AnimationStrategy.Freeze,
          ),
        },
      ] as const;
    }),
  ),
);

export const loader = new Loader();
for (const res of Object.values(Resources)) {
  loader.addResource(res);
}
